/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Collapse, Descriptions, Divider, Typography } from 'antd';

// Misc imports
import is from '../../../utils/is';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const SessionContactTab = ({ chatSession }) => {

  const { t } = useTranslation();

  const formatCustomDataValue = (value) => {
    if (is.boolean(value) || is.number(value)) {
      return value.toString();
    }

    if (is.string(value) && value.trim()) {
      return value.trim();
    }

    if (is.object(value)) {
      return JSON.stringify(value);
    }

    return <Text className="text-secondary">{t('(Not available)')}</Text>;
  };

  return (
    <div className="overflow-y-auto pl-2 pr-2 overflow-x-hidden" style={{ maxHeight: 590 }}>
      <Text className={'fw-bold fs-lg mb-3 d-block'}>{t('Contact')}</Text>
      <Descriptions
        bordered={true}
        column={1}
        labelStyle={{ fontWeight: 500, backgroundColor: 'inherit' }}
        contentStyle={{ backgroundColor: 'inherit' }}
      >
        <Descriptions.Item label={t('Contact Full Name:')}>
          {chatSession.metadata?.subscriberName ? chatSession.metadata.subscriberName
            : <Text className="text-secondary">{t('(Not available)')}</Text>}
        </Descriptions.Item>

        <Descriptions.Item label={t('Contact Email:')}>
          {chatSession.metadata?.subscriberEmail ? chatSession.metadata.subscriberEmail
            : <Text className="text-secondary">{t('(Not available)')}</Text>}
        </Descriptions.Item>
      </Descriptions>

      {
        chatSession.metadata?.subscriberCustomData && !is.emptyObject(chatSession.metadata?.subscriberCustomData) ? (
          <Collapse defaultActiveKey={['1']} ghost>
            <Collapse.Panel
              showArrow={false}
              collapsible="icon"
              header={
                <Divider className="fs-base ant-divider-primary" orientation="left">
                  <Text strong>
                    <span className="title">
                      {t('Contact\'s Custom Data')}
                    </span>
                  </Text>
                </Divider>
              }
              key="1"
            >
              <Descriptions
                bordered={true}
                column={1}
                labelStyle={{ fontWeight: 500, backgroundColor: 'inherit' }}
                contentStyle={{ backgroundColor: 'inherit' }}
              >
                {
                  Object.entries(chatSession.metadata?.subscriberCustomData || {}).map(([key, value]) => (
                    <Descriptions.Item label={`${key}:`} key={key}>
                      {formatCustomDataValue(value)}
                    </Descriptions.Item>
                  ))
                }
              </Descriptions>
            </Collapse.Panel>
          </Collapse>
        ) : null
      }
    </div>
  );
};

SessionContactTab.propTypes = {
  chatSession: PropTypes.array
};

export default SessionContactTab;
